export const evalRole = {
    name: 'eval',
    body: {
        type: String,
        required: true,
    },
    run(data) {
        const value = data.body;
        const node = {
            type: 'inlineExpression',
            value,
        };
        return [node];
    },
};
